import * as React from 'react';

import {
  ResolutionStatus,
  type SuggestionAction,
} from 'bundles/ai-coach-platform/components/patterns/suggestions/types';

export type CoachSuggestionState = {
  id: string;
  status: ResolutionStatus;
  isExpanded: boolean;
  collapseOnAction: boolean;
  onAction: (action: SuggestionAction) => Promise<void> | void;
  onToggle: (expanded: boolean) => void;
};

export const CoachSuggestionContext = React.createContext<CoachSuggestionState>({
  id: '',
  status: ResolutionStatus.UNRESOLVED,
  isExpanded: false,
  collapseOnAction: true,
  onAction: () => undefined,
  onToggle: () => undefined,
});

export const useCoachSuggestionContext = () => React.useContext(CoachSuggestionContext);
